import {
  DesignMaterialItemDto,
  GeopickingItemDto,
  Map3DObjectListDto,
  SeaSurveyListDto,
} from "~/api/GeneratedApi";
import {
  CesiumCadItem,
  CesiumGeopickingItem,
  CesiumImageryItem,
  CesiumMeasurementItem,
  CesiumTerrainItem,
} from "../types/CesiumMapItems";

export const seaSurveyToCesiumMapItem = (
  s: SeaSurveyListDto,
): CesiumMeasurementItem => {
  return {
    id: s.id,
    mapId: `measurement${s.id}`,
    name: s.name,
    type: "measurement",
    layer: "pointcloud",
    description: s.description,
    files: s.files,
    coordinateSystem: s.coordinateSystem,
    mapAreas: s.mapAreas,
    additionalHeightOffsetMm: s.additionalHeightOffsetMm,
    comparisonLevelOffsetMm: s.comparisonLevelOffsetMm,
  };
};

export const geopickingToCesiumMapItem = (
  g: GeopickingItemDto,
): CesiumGeopickingItem => {
  return {
    ...g,
    mapId: `geopicking${g.id}`,
    geopickingType: g.type,
    type: "geopicking",
    layer: "geopicking",
  };
};

export const imageryToCesiumMapItem = (
  o: Map3DObjectListDto,
): CesiumImageryItem => ({
  ...o,
  mapId: `imagery${o.id}`,
  type: "imagery",
  layer: null,
});
export const terrainToCesiumMapItem = (
  o: Map3DObjectListDto,
): CesiumTerrainItem => ({
  ...o,
  mapId: `terrain${o.id}`,
  type: "terrain",
  layer: null,
});

export const cadToCesiumMapItem = (
  d: DesignMaterialItemDto,
): CesiumCadItem[] => {
  const ret = [] as CesiumCadItem[];
  d.files?.forEach((f) => {
    ret.push({
      id: f.id,
      name: f.fullName ?? f.id.toString(),
      mapId: `cad${f.id}`,
      type: "cad",
      layer: null,
      mapArea: d.mapArea,
      state: f.queuedFile?.stateId,
      designMaterialId: d.id,
    });
  });
  return ret;
};
